module.exports = __webpack_public_path__ + "public/img/video-sell.c387d46a.jpg";